import { init } from "echarts"

export default {

    sourceProxy:function(){
        var sourceLevels=[];
        var sourceLevelCodeDic={};
        var sourceLevelKeyDic={};
        var maxSourceLevel=null;

        this.init=function(){
            sourceLevels=JSON.parse(localStorage.getItem("sourceLevels"));
            if(sourceLevels!=null){
                sourceLevels= sourceLevels.sort(function (a, b) {
                    return b.orderby === a.orderby ? 0:(a.orderby>b.orderby?1:-1);                       
                 });
                for (const iterator of sourceLevels) {
                    sourceLevelCodeDic[iterator.code]=iterator;    
                    sourceLevelKeyDic[iterator.levelkey]=iterator;
                }
                if(sourceLevels.length>0){
                    maxSourceLevel=sourceLevels[0];
                }
            }    
        }
        this.getSourceLeveByKey=function(key){
           return sourceLevelKeyDic[key];
        }

        this.getSourceLeveCodeByKey=function(key){
            
            return sourceLevelKeyDic[key]!=null?sourceLevelKeyDic[key].code:-1;
         }

        this.getSourceLeveByCode=function(code){
            return sourceLevelCodeDic[code]
        }

        this.getSourceLeveCodeByCode=function(code){
            return sourceLevelCodeDic[code]!=null ? sourceLevelCodeDic[code].code:-1;
        }

        this.getTopSourceLeveByKey=function(key){
            var n=sourceLevelKeyDic[key];
            if(n!=null){
               return sourceLevelCodeDic[n.parentCode]
            }
            return null;
        }

        this.getTopSourceLeveBySourceName=function(key){
            var n=sourceLevelKeyDic[key];
            if(n!=null){
               return sourceLevelCodeDic[n.parentCode]
            }
            return null;
        }
     
        this.getMaxSourceLevelCode=function(code){
            return maxSourceLevel==null?0: maxSourceLevel.code;
        }
        this.getSourceLevels=function(){
            return sourceLevels;
        }

        this.hasLevel=function(key){
            console.log(sourceLevelKeyDic)
            if(sourceLevelKeyDic[key]){
                return true;
            }else{
                return false;
            }
        }
    },
    testDoor(v){
        let reg=/^\d{1,2}[\-][bB]{0,1}\d{1,2}[\-]\d{1,2}$/;
        return reg.test(v);
    },

    testNumberStr(v){
        let reg = /^(\d+)?$/;
        return reg.test(v);
    },
    testDouble(v){
        let reg = /^(-?\d+)(\.\d+)?$/;
        return reg.test(v);
    },

    testInteger(v){
        let reg = /^(-?\d+)$/;
        return reg.test(v);
    },

    testPhone(v){
        let reg = /^1[3456789]\d{9}$/;
        return reg.test(v);
    },

    testFixedPhone(v){
        let reg=/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
        return reg.test(reg);
    },

    testPhoneOrFixed(v){
        let reg = /^1[3456789]\d{9}$/;
        let reg2=/^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
        return reg.test(v) || reg2.test(v);
    },

    testIdcard(v){

        //var reg3 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;


        let reg=/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;

        let reg2=/^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$/;

        return reg.test(reg)||reg2.test(reg)

    },


    isEmpty(str){
       return str==null ||str==undefined || ""===str
    },
    isNotEmpty(str){
        return !(str==null ||str==undefined ||""===str)
    },


    appentParamNotEmpty(param,key,value){
        if(isNotEmpty(value)){
            param.append(key,value); 
        }
    },

    URLSearchParamsNotEmpty:function (key,value) {
        var param= new URLSearchParams();

        this.isNotEmpty=function(str){
            return !(str==null ||str==undefined ||""===str)
        }
        this.appentParamNotEmpty=function(param,key,value){
            if(this.isNotEmpty(value)){
                param.append(key,value); 
            }
        }

        this.setParamNotEmpty=function(param,key,value){
            if(this.isNotEmpty(value)){
                param.set(key,value); 
            }
        }

        this.append=function(key,value){
            if(typeof(value)=='string'){
                value=value!=undefined? value.trim():value;
            }
            this.appentParamNotEmpty(param,key,value);
        },

        this.set=function(key,value){
            if(typeof(value)=='string'){
                value=value!=undefined? value.trim():value;
            }
            this.setParamNotEmpty(param,key,value);
        },

        this.getParam=function(){
            return param;
        } 
    },

    URLSearchParamsNotNull:function (key,value) {
        var param= new URLSearchParams();

        this.isNotEmpty=function(str){
            return !(str==null ||str==undefined)
        }
        this.appentParamNotEmpty=function(param,key,value){
            if(this.isNotEmpty(value)){
                param.append(key,value); 
            }
        }
        this.setParamNotEmpty=function(param,key,value){
            if(this.isNotEmpty(value)){
                param.set(key,value); 
            }
        }

        this.append=function(key,value){
            if(typeof(value)=='string'){
                value=value!=undefined? value.trim():value;
            }
            this.appentParamNotEmpty(param,key,value);
        },

        this.set=function(key,value){
            if(typeof(value)=='string'){
                value=value!=undefined? value.trim():value;
            }
            this.setParamNotEmpty(param,key,value);
        },

        this.getParam=function(){
            return param;
        }
    
    },

}


//////////////////
// WEBPACK FOOTER
// ./static/js/MyUtil.js
// module id = null
// module chunks = 